// frontend/src/utils/cashierUtils.js
import moment from 'moment-timezone';

export const VENEZUELA_TIMEZONE = 'America/Caracas';

export const getHorseColor = (number) => {
    const colors = {
        1: { bg: '#e91c24', text: '#ffffff' }, 2: { bg: '#ffffff', text: '#000000' },
        3: { bg: '#005eb8', text: '#ffffff' }, 4: { bg: '#ffde00', text: '#000000' },
        5: { bg: '#009639', text: '#ffffff' }, 6: { bg: '#000000', text: '#ffde00' },
        7: { bg: '#ff7900', text: '#000000' }, 8: { bg: '#f472d0', text: '#000000' },
        9: { bg: '#00bce4', text: '#000000' }, 10: { bg: '#672146', text: '#ffffff' },
        11: { bg: '#9ca3af', text: '#b91c1c' }, 12: { bg: '#84cc16', text: '#000000' },
        13: { bg: '#78350f', text: '#ffffff' }, 14: { bg: '#7f1d1d', text: '#ffffff' },
        15: { bg: '#fef08a', text: '#000000' }
    };
    return colors[number] || { bg: '#64748b', text: '#ffffff' }; 
};

export function calculateTimeRemaining(startTimeUTC) {
    const distance = startTimeUTC.diff(moment.utc());
    if (distance < 0) return 'MTP 0';
    const duration = moment.duration(distance);
    return `${String(Math.floor(duration.asHours())).padStart(2, '0')}:${String(duration.minutes()).padStart(2, '0')}:${String(duration.seconds()).padStart(2, '0')}`;
}

export function calculateGrandTotal(bets) {
    return bets.reduce((total, b) => total + b.win + b.place + b.show, 0);
}